import {
  MdRestaurantMenu,
  MdCheckCircle,
  MdPeople,
  MdCurrencyRupee,
} from "react-icons/md";

import "./CateringStats.css";

function CateringStats({ packages }) {
  const totalPackages = packages.length;

  const activePackages = packages.filter(
    (item) => item.isAvailable
  ).length;

  const totalGuests = packages.reduce(
    (sum, item) => sum + Number(item.maximumGuests || 0),
    0
  );

  const averagePrice =
    totalPackages === 0
      ? 0
      : Math.round(
          packages.reduce(
            (sum, item) =>
              sum + Number(item.pricePerPlate || 0),
            0
          ) / totalPackages
        );

  const stats = [
    {
      title: "Packages",
      value: totalPackages,
      icon: <MdRestaurantMenu />,
    },
    {
      title: "Active",
      value: activePackages,
      icon: <MdCheckCircle />,
    },
    {
      title: "Max Guests",
      value: totalGuests,
      icon: <MdPeople />,
    },
    {
      title: "Avg Price",
      value: `₹${averagePrice}`,
      icon: <MdCurrencyRupee />,
    },
  ];

  return (
    <div className="catering-stats">
      {stats.map((stat) => (
        <div
          className="catering-stat-card"
          key={stat.title}
        >
          <div className="stat-icon">
            {stat.icon}
          </div>

          <div className="stat-info">
            <h3>{stat.value}</h3>
            <p>{stat.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CateringStats;